import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  noResultsNoSearchTerm: {
    id: 'noresults.noresults',
    description:
      'Description shown when no results are found and the search had no search term',
    defaultMessage: 'No results match your search.'
  },
  noResultsFor: {
    id: 'noresults.noresultsFor',
    description: 'Description shown when no results are found for the search',
    defaultMessage: 'No results for "{searchTerm}"'
  },
  noResultsSubtitle: {
    id: 'noresults.subtitle',
    description:
      'Subtitle on no results page with guidance on how to modify query to get results',
    defaultMessage:
      'Try a common search below, clear any filters, or check your spelling and use fewer words.'
  },
  suggestedSearchesHeading: {
    id: 'noresults.suggestedSearchesHeading',
    description:
      'Heading for the suggested searches section on the no results page',
    defaultMessage: 'Suggested Searches'
  },
  commonSearchesHeading: {
    id: 'noresults.commonSearchesHeading',
    description:
      'Heading for the common searches section on the no results page',
    defaultMessage: 'Common Searches'
  },
  needHelpHeading: {
    id: 'noresults.needHelpHeading',
    description:
      'Heading for the need help panel in the sidebar on the no results page',
    defaultMessage: 'Need help?'
  },
  needHelpDescription: {
    id: 'noresults.needHelpDescription',
    description:
      'Description for the need help panel in the sidebar on the no results page',
    defaultMessage:
      'Our care team can help you find the right provider and get you scheduled.'
  },
  needHelpPhoneNumber: {
    id: 'noresults.needHelpPhoneNumber',
    description:
      'Phone number for the need help panel in the sidebar on the no results page',
    defaultMessage: '{phoneNumber}'
  },
  needHelpHours: {
    id: 'noresults.needHelpHours',
    description:
      'Optional business hours for the need help panel in the sidebar on the no results page',
    defaultMessage: ' '
  },
  patientPortalHeading: {
    id: 'noresults.patientPortalHeading',
    description:
      'Heading for the patient portal section on the no results page',
    defaultMessage: 'Already a patient?'
  },
  patientPortalDescription: {
    id: 'noresults.patientPortalDescription',
    description:
      'Description for the patient portal section on the no results page',
    defaultMessage: 'Sign in to message your care team or schedule.'
  },
  patientPortalButton: {
    id: 'noresults.patientPortalButton',
    description:
      'Button text for the patient portal section on the no results page',
    defaultMessage: 'Sign in to Patient Portal'
  }
});
